import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/use-locale';
import { cn } from '@/lib/utils';

interface LocaleSwitcherProps {
  className?: string;
  variant?: 'compact' | 'segmented';
}

export function LocaleSwitcher({ className, variant = 'segmented' }: LocaleSwitcherProps) {
  const { t } = useTranslation('common');
  const { lang, setLang, supported } = useLocale();

  return (
    <div
      className={cn(
        variant === 'segmented' ? 'lang-switch' : 'inline-flex items-center gap-1',
        className
      )}
      role="group"
      aria-label={t('accessibility.language')}
    >
      {supported.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
